<template>
  <div class="menu-nav-view border-bottom-1px">
    <div class="menu-list" ref="menuWrapper">
      <ul class="menu-list-ul ui-rows-m" ref="menuListUl" id="menu-list-ul">
        <li v-for="(item,index) in menuCategory" :key="index" :data-c="{'active':index == clickIndex}" :class="{'active':index == clickIndex}" class="menu-li-hook" @click="$parent.selectedSortLabel($event,index,item.categoryLevelId)">{{item.categoryLevelName}}</li>
      </ul>
    </div>
    <div class="menu-sort-btn" @click="isShowSort=!isShowSort"><span class="icon-sort" :class='statusBg(getResultType)'></span></div>
    <div class="menu-sort-option" v-show="isShowSort" @click="isShowSort=false">
      <ul class="selected-sort">
        <li class="border-bottom-1px gray-dee" :class="{selected: sortIndex===index}" v-for="(item,index) in selectedSortList" :key="item" @click="$parent.selectedSort(index)">{{item}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BScroll from 'better-scroll';
import { InfiniteScroll } from 'mint-ui';
Vue.use(InfiniteScroll);
export default {
  data() {
    return {
      isShowSort: false,
      menuScroll:null, //菜单栏-滚动BScroll
    }
  },
  props: {
    menuCategory:{
      type:Array,
      default(){
        return []
      }
    },
    selectedSortList:{
      type:Array,
      default(){
        return []
      }
    },
    clickIndex:{
      type: Number,
      default(){
        return 0
      }
    },
    sortIndex:{
      type: Number,
      default(){
        return 0
      }
    },
    getResultType:{
      type: Number,
      default(){
        return 0
      }
    }
    
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    _initMenuScroll(){
      let children = this.$refs.menuListUl.children;
      let width = 0, marginRight=0;
      for (let i = 0; i < children.length; i++) {
        let item = children[i];
        width += item.offsetWidth;
        marginRight += parseFloat(document.defaultView.getComputedStyle(item).marginRight.split("px")[0]);
      }
      this.$refs.menuListUl.style.width = width + marginRight + 10 + 'px'; //获取全部总长度
    },
    initSlide() {
      if(!this.menuScroll && this.$refs.menuWrapper){
        this.menuScroll = new BScroll(this.$refs.menuWrapper, {
          scrollX: true,
          scrollY: false,
          click: true
        });
      }else{
        this.menuScroll.refresh();
      }
    },
    /**
     * 根据不同的状态显示不同的按钮
     * // 0 默认  1 价格由低到高 2 价格由高到低
     */
    statusBg(status) {
      switch (status) {
        case 0:
          return 'icon-selecteds';
          break;
        case 1:
          return 'icon-search-on';
          break;
        case 2:
          return 'icon-downs';
          break;
      }
    },
    /**
     * 设置默认选中的场次
     */
    setDefaultActivityTimeId(){
      //被选中个数的前面li的个数
      this.$nextTick(() => {
        let preLen = document.querySelectorAll(".menu-list-ul li");
        let dom_arr = []
        for (let i = 0; i < preLen.length; i++) {
          if(preLen[i].className.indexOf('active') > -1){
            break;
          }else {
            dom_arr.push(preLen[i])
          }
        }
        let index = this.clickIndex;
        let nodeList = document.getElementById("menu-list-ul") && document.getElementById("menu-list-ul").childNodes;
        let currNode = null;
        // 快速切换菜单将导致控制台报错因为dom不存在
        if (!nodeList) {
          return;
        };
        for(let i = 0;i < nodeList.length;i++){
          if(i == index){
            currNode = nodeList[i];
          }
        }
        if(dom_arr.length >= 1){
          //滚动到前面一个dom的位置
          this.menuScroll.scrollToElement(currNode.previousSibling);
        }else{
          //滚动到当前位置
          this.menuScroll.scrollToElement(currNode);
        }
      })
    },
    // 计算滚动位置
    calcSroll(data, index) {
      const currScroll = this.menuScroll
      const liLen = this.menuCategory.length - 1
      let preNode = null;
      if(index > 0){
        // previousSibling获取前一个兄弟节点
        preNode = data.previousSibling;
      }
      if(index < 3){
        // 前面3个不用滑动
        currScroll.scrollTo(0,0);
      } else if (liLen - index < 3) {
        const scrollLeft = currScroll.maxScrollX; //IScroll最大的滚动位置，滚动到底部
        currScroll.scrollTo(scrollLeft,0);
      } else {
        // 获取当前元素的前面2个元素
        currScroll.scrollToElement(preNode);
      }
    }

  }
};
</script>

<style lang="less" scoped>
.menu-nav-view{
  display: flex;
  width: 100%;
  height: 1rem;
  .menu-list{
    position: relative;
    box-sizing: border-box;
    width: 90%;
    height: 1rem;
    margin: 0 0.32rem;
    overflow: hidden;
    white-space: nowrap;
    .menu-list-ul{
      height: 1rem;
      .menu-li-hook{
        margin-right: 0.5rem;
        font-size: 0.28rem;
        height: 0.88rem;
        line-height: 0.88rem;
        color: #505050;
        flex: 0 0 auto;
        border-bottom: 3px solid #fff;
        &:last-of-type{
          margin-right: 0;
        }
        &.active{
          color: #f10d3b;
          border-bottom: 3px solid #f10d3b;
        }
      }
    }
  }
  .menu-sort-btn{
    flex-shrink: 0;
    width: .98rem;
    height: .98rem;
    background: #fff;
    .icon-selecteds { 
      background: url('//static.yunjiweidian.com/qnUpload/frontend/icon/icon_selected.png') no-repeat; 
    }
    .icon-downs { 
      background: url('//static.yunjiweidian.com/qnUpload/frontend/logo/icon-down.png') no-repeat;
    }
    .icon-search-on { 
      background: url('//static.yunjiweidian.com/qnUpload/frontend/logo/icon-search-on.png') no-repeat;
    }
    .icon-sort { 
      display: inline-block; margin: .24rem  0 0 .22rem; width: .52rem; height: .52rem; background-size: 100% 100%;
    }
  }
  
  .menu-sort-option{
    position: fixed;
    top: 1.92rem;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 666;
    .selected-sort{
      width: 100%;
      background: #fff;
      li{
        margin: 0 auto;
        width: 7.1rem;
        height: 1rem;
        line-height: 1rem;
        font-size: .28rem;
        &.selected{
          color: #f10d3b;
          background: url('//static.yunjiweidian.com/qnUpload/frontend/logo/icon-gou.png') no-repeat 100%;
          background-size: .4rem .4rem;
        }
      }
    }
  }
}
</style>